import React, { useEffect, useInsertionEffect, useState } from 'react'
import { Link } from 'react-router-dom';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
export default function CreateAccount() {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [cPassword, setCPassword] = useState('');

    const [isFirstName, setIsFirstName] = useState(false);
    const [isLastName, setIsLastName] = useState(false);
    const [isEmail, setIsEmail] = useState(false);
    const [isPhone, setIsPhone] = useState(false);
    const [isPassword, setIsPassword] = useState(false);
    const [isMatch, setIsMatch] = useState(false);
    const [isValid, setIsValid] = useState(false);

    const [confirmFocus, setConfirmFocus] = useState(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+}{":?><|]{8,}$/;
    const phoneRegex = /^\+?[1-9]\d{9,14}$/;

    const handleVerify = async (e) => {
        try {
            // const fullName = `${firstName.trim()} ${lastName.trim()}`;
            const response = await fetch(`${backendUrl}/createAccount`, {
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({ firstName, lastName, email, phone, password }),
            });

            const data = await response.json();

            if (response.ok) {
                alert("Account created successfully");
                window.location.href = '/login';
            } else {
                alert(data.message || "Username Already Exists");
            }
        } catch (error) {
            console.error("Error creating account:", error);
            alert("Something went wrong");
        }
    };

    useEffect(() => {
        setIsFirstName(firstName.trim().length > 0);
    }, [firstName]);

    useEffect(() => {
        setIsLastName(lastName.trim().length > 0);
    }, [lastName]);

    useEffect(() => {
        setIsEmail(emailRegex.test(email));
    }, [email]);

    useEffect(() => {
        setIsPhone(phoneRegex.test(phone));
    }, [phone]);

    useEffect(() => {
        setIsPassword(passwordRegex.test(password));
    }, [password]);

    useEffect(() => {
        setIsMatch(password === cPassword && password.length > 0);
    }, [password, cPassword]);

    useEffect(() => {
        setIsValid(isFirstName && isLastName && isEmail && isPassword && isMatch && isPhone);
    }, [isFirstName, isLastName, isEmail, isPassword, isMatch, isPhone]);

    useEffect(() => {
        window.scrollTo({ top: 2, behavior: 'smooth' });
    }, []);
    return (
        <div className='createAccount'>
            <div className='signIn row'>
                <div className='form col-md-3 col-sm-2 ahaa' style={{ margin: '0px 15px' }}>
                    <Link to='/signIn'>Already have an account</Link>
                </div>
            </div>

            <div className='signIn row' style={{ marginTop: '3rem' }}>
                <div className='form col-md-3 col-sm-2' style={{ margin: '15px 15px' }}>
                    <h3 style={{ marginBottom: '3rem' }}>Create Account</h3>

                    <div className='row'>
                        <div className='col-md-6'>
                            <label htmlFor="firstName">
                                {!isFirstName && firstName !== '' && (
                                    <div style={{ fontSize: '12px', fontWeight: '300' }}>
                                        <span>First name is required! </span>
                                        <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                                    </div>
                                )}
                            </label>
                            <input
                                type="text"
                                name="firstName"
                                autoComplete="off"
                                id="firstName"
                                placeholder="First Name"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            /><br />
                        </div>

                        <div className='col-md-6'>
                            <label htmlFor="lastName">
                                {!isLastName && lastName !== '' && (
                                    <div style={{ fontSize: '12px', fontWeight: '300' }}>
                                        <span>Last name is required! </span>
                                        <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                                    </div>
                                )}
                            </label>
                            <input
                                type="text"
                                name="lastName"
                                autoComplete="off"
                                id="lastName"
                                placeholder="Last Name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            /><br />
                        </div>
                    </div>

                    <label htmlFor="email">
                        {!isEmail && email !== '' && (
                            <div style={{ fontSize: '12px', fontWeight: '300' }}>
                                <span>Please enter a valid email address </span>
                                <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                            </div>
                        )}
                        {isEmail && (
                            <div style={{ fontSize: '12px' }}>
                                <i className="fa-solid fa-circle-check" style={{ color: "green" }}></i>
                            </div>
                        )}
                    </label>
                    <input
                        type="text"
                        name="email"
                        autoComplete='off'
                        id="email"
                        placeholder='Email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    /><br />

                    <label htmlFor="phone">
                        {!isPhone && phone !== '' && (
                            <div style={{ fontSize: '12px', fontWeight: '300' }}>
                                <span>Please enter a valid phone </span>
                                <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                            </div>
                        )}
                        {isPhone && (
                            <div style={{ fontSize: '12px' }}>
                                <i className="fa-solid fa-circle-check" style={{ color: "green" }}></i>
                            </div>
                        )}
                    </label>
                    <input
                        type="text"
                        name="phone"
                        autoComplete='off'
                        id="phone"
                        placeholder='Mobile Number'
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    /><br />

                    <label htmlFor="password">
                        {!isPassword && password !== '' && (
                            <div style={{ fontSize: '12px', fontWeight: '300' }}>
                                <span>Password must be at least 8 characters long and include at least one letter and one number </span>
                                <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                            </div>
                        )}
                        {isPassword && (
                            <div style={{ fontSize: '12px' }}>
                                <i className="fa-solid fa-circle-check" style={{ color: "green" }}></i>
                            </div>
                        )}
                    </label>
                    <input
                        type="password"
                        name="password"
                        id="password"
                        placeholder='Password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    /><br />

                    <label htmlFor="cPassword">
                        {(isPassword && !isMatch && confirmFocus) && (
                            <div style={{ fontSize: '12px', fontWeight: '300' }}>
                                <span style={{ color: "red" }}>Password Mismatch</span>
                                <i className="fa-solid fa-circle-xmark" style={{ color: "red" }}></i>
                            </div>
                        )}
                        {(isPassword && isMatch && confirmFocus) && (
                            <div style={{ fontSize: '12px' }}>
                                <i className="fa-solid fa-circle-check" style={{ color: "green" }}></i>
                            </div>
                        )}
                    </label>
                    <input
                        type="password"
                        name="cPassword"
                        id="cPassword"
                        placeholder='Confirm Password'
                        value={cPassword}
                        onFocus={() => setConfirmFocus(true)}
                        // onBlur={() => setConfirmFocus(false)}
                        onChange={(e) => setCPassword(e.target.value)}
                    />

                    <button
                        className="btn create-account"
                        onClick={handleVerify}
                    disabled={!(isEmail && isPassword && isMatch && isPhone && isFirstName && isLastName)}
                    >
                        Verify your credentials
                    </button>
                </div>
            </div>
        </div>

    )
}
